import {
  FormGroup,
  Label,
  TextInput
} from '../../section.styles.jsx';

const SubtitleUpdateSection = ({ content = {}, metadata = {}, onChange }) => {
  const handleTextChange = (e) => {
    const newText = e.target.value;
    onChange({
      content: { text: newText },
      metadata: {}
    });
  };

  return (
    <FormGroup>
      <Label htmlFor="subtitle-text">Subtitle Text</Label>
      <TextInput
        id="subtitle-text"
        type="text"
        value={content?.text || ''}
        onChange={handleTextChange}
        placeholder="Enter subtitle text..."
      />
    </FormGroup>
  );
};

export default SubtitleUpdateSection;